<template>
  <div class="error-state" :class="{ 'state-bordered': bordered }">
    <div class="error-state__icon">
      <v-icon
        :data-testid="sectionTag ? `${sectionTag}-icon` : undefined"
        :icon="props.icon"
        color="red600"
      ></v-icon>
    </div>
    <h4 class="text-red600" :data-testid="sectionTag ? `${sectionTag}-headline` : undefined">
      {{ props.headline }}
    </h4>
    <div v-if="props.body" class="error-state__body">
      <span :data-testid="sectionTag ? `${sectionTag}-body` : undefined" class="body-regular-large" v-dompurify-html="props.body"></span>
    </div>
    <div v-if="props.linkUrl && props.linkText" class="error-state__link">
      <a :data-testid="sectionTag ? `${sectionTag}-link` : undefined" :href="props.linkUrl">{{
        props.linkText
      }}</a>
    </div>
    <div v-if="props.buttonText" class="error-state__button">
      <v-btn :data-testid="sectionTag ? `${sectionTag}-button` : undefined" color="secondary" size="small">
        <v-icon
          v-if="props.buttonIcon"
          :data-testid="sectionTag ? `${sectionTag}-button-icon` : undefined"
          :icon="props.buttonIcon"
        ></v-icon>
        {{ props.buttonText }}
      </v-btn>
    </div>
  </div>
</template>

<script setup lang="ts">
import { colors } from '@/plugins/vuetify'
import { $t } from '@/plugins/i18n'
import { mdiBell } from '@mdi/js'

export interface ErrorStateProps {
  sectionTag?: string
  icon?: string
  headline?: string
  body?: string
  linkText?: string
  linkUrl?: string
  buttonText?: string
  buttonIcon?: string
  bordered?: boolean
}

const props = withDefaults(defineProps<ErrorStateProps>(), {
  sectionTag: 'unspecified',
  icon: mdiBell,
  headline: $t('app.common.messages.errorState.headline'),
  body: $t('app.common.messages.errorState.body'),
  linkText: 'customersuccess@gettattle.com',
  linkUrl: 'mailto:customersuccess@gettattle.com',
  buttonText: '',
  buttonIcon: '',
  bordered: true
})


</script>

<style lang="scss" scoped>
.error-state {
  display: flex;
  align-items: center;
  max-width: 600px;
  margin: 0 auto;
  flex-direction: column;
  padding-top: 45px;
  padding-bottom: 45px;

  &.state-bordered {
    border: 1px solid v-bind('colors.neutral.neutral300');
    border-radius: 4px;
    max-width: 100%;
  }
}

.error-state__icon {
  .v-icon {
    width: 50px;
    height: 50px;
  }
}

.error-state__body {
  text-align: center;
}

.error-state__button {
  margin-top: 45px;
  margin-bottom: 45px;
}

.error-state__link,
.error-state__body {
  a {
    color: v-bind('colors.blue.blue600') !important;
    text-decoration: underline;
  }
}
</style>
